import React, {useState} from 'react';
import {
    TextInput,
    DateInput,
    SelectInput,
    Create,
    SimpleForm,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    Notification,
    
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import BooleanInput from '../controls/BoolNumInput'
import SelectCategory from './SelectCategory'


let ssn = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const EquipmentEditActions = ({props}) => (
     ssn = (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn,
    <CardActions style={cardActionStyle}>

        <ListButton basePath={'/equipregister'} label='Equipment List'/>
    </CardActions>
);

const editStyles = {
    root: { alignItems: 'flex-start'},
    initial: {  width: '5em' },
    booth: {  width: '2em' },
    time: {  width: '7em' },
    volume: {  width: '3em' },
    comments: {  width: '30em' },
};

const action = [
    {
        id: 'Approved',
        name: 'Approved'
    },
    {
        id : 'Defer Donor',
        name: 'Defer Donor'
    },
    {
        id : 'Draw New Sample',
        name: 'Draw New Sample'
    }
  ]
  

const EquipmentToolbar = props => (
    <Toolbar {...props} >
        {ssn = (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn }
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);


const EquipmentCreate =({ classes, ...props }) => (
    
<Create 
    title='Equipment Add' 
    {...props}  
    actions={<EquipmentEditActions props={props}/>} 
    >
   <SimpleForm toolbar={<EquipmentToolbar />}> 
       < SelectCategory   validate={required()} />
       <TextInput source="equip_id" label="Equipemnt ID"  validate={required()} />
       <TextInput source="manufacturer" label="Manufacturer" />
       <TextInput source="serial_num" label="serial_num" />
       <BooleanInput source="status" label="Is Active?" />
   </SimpleForm>
    </Create>
);

export default withStyles(editStyles)(EquipmentCreate);
